import ReactGA from 'react-ga4';

console.log('[GA4] measurement ID:', process.env.REACT_APP_GA_MEASUREMENT_ID);

let initialized = false;

export const initGA = () => {
  const id = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!id) {
    console.warn('[GA4] 測定IDが未設定のため初期化をスキップします (REACT_APP_GA_MEASUREMENT_ID)');
    return;
  }
  ReactGA.initialize(id);
  initialized = true;
  console.log('[GA4] initialized:', id);
};

export const trackPageView = (path) => {
  if (!initialized) return;
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (name, params = {}) => {
  if (!initialized) return;
  ReactGA.event(name, params);
};
